import Cookies from 'js-cookie';
import {COOKIES} from '@util/StorageUtils';
import {setContext} from 'apollo-link-context';

export const PENDING_ORDER_HEADER = 'x-pending-order';
export const PENDING_ORDER_STORAGE_KEY = 'checkout.pendingOrder';
export const PENDING_ORDER_CLEAR_QUERY = 'clearPendingOrder';

const getServerUserInfo = () =>
    typeof window === 'undefined' ? undefined : window.upi?.User?.info;

export const hasPendingOrderContext = ( storage = window.sessionStorage, userInfo = getServerUserInfo() ) =>
    Boolean( userInfo?.pendingOrderGuid || storage?.getItem?.( PENDING_ORDER_STORAGE_KEY ) );

export const clearPendingOrderContext = ( storage = window.sessionStorage, userInfo = getServerUserInfo() ) => {
    storage?.removeItem?.( PENDING_ORDER_STORAGE_KEY );

    if ( userInfo ) {
        userInfo.pendingOrderGuid = '';
    }
};

const getPendingOrder = ( location = window.location, storage = window.sessionStorage, userInfo = getServerUserInfo() ) => {
    const query = new URLSearchParams( location.search );
    const pendingOrder = query.get( 'pendingOrder' );

    if ( query.has( PENDING_ORDER_CLEAR_QUERY ) ) {
        clearPendingOrderContext( storage, userInfo );
        return null;
    }

    if ( pendingOrder ) {
        storage?.setItem?.( PENDING_ORDER_STORAGE_KEY, pendingOrder );
        return pendingOrder;
    }

    if ( userInfo?.pendingOrderGuid ) {
        storage?.setItem?.( PENDING_ORDER_STORAGE_KEY, userInfo.pendingOrderGuid );
        return userInfo.pendingOrderGuid;
    }

    return storage?.getItem?.( PENDING_ORDER_STORAGE_KEY );
};

export const getPendingOrderHeader = ( location = window.location, storage = window.sessionStorage, userInfo = getServerUserInfo() ) => {
    const pendingOrder = getPendingOrder( location, storage, userInfo );

    return pendingOrder ? {[PENDING_ORDER_HEADER]: pendingOrder} : {};
};

const authLink = setContext( ( _, {headers} ) => {
    const TOKEN = Cookies.get( COOKIES.AUTH_TOKEN.name );
    const authHeader = TOKEN ? {authorization: `Bearer ${TOKEN}`} : {};
    return {
        headers: {
            ...headers,
            ...authHeader,
            ...getPendingOrderHeader()
        }
    };
} );

export default authLink;
